import {
    Pagination,
    Dialog,
    Autocomplete,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Menu,
    Submenu,
    MenuItem,
    MenuItemGroup,
    Input,
    InputNumber,
    Radio,
    RadioGroup,
    RadioButton,
    Checkbox,
    CheckboxButton,
    CheckboxGroup,
    Switch,
    Select,
    Option,
    // OptionGroup,
    Button,
    ButtonGroup,
    Table,
    TableColumn,
    DatePicker,
    TimeSelect,
    TimePicker,
    Popover,
    Tooltip,
    MessageBox,
    Breadcrumb,
    BreadcrumbItem,
    Form,
    FormItem,
    Tabs,
    TabPane,
    Tag,
    Tree,
    // Alert,
    Notification,
    // Slider,
    Loading,
    Icon,
    Row,
    Col,
    Upload,
    Progress,
    Spinner,
    Message,
    // Badge,
    Card,
    // Rate,
    Steps,
    Step,
     Carousel,
    Scrollbar,
    CarouselItem,
    Collapse,
    CollapseItem,
    Cascader,
    // ColorPicker,
    Transfer
    // locale
} from 'element-ui'

const components = [
    Pagination,
    Dialog,
    Autocomplete,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Menu,
    Submenu,
    MenuItem,
	MenuItemGroup,
    Input,
    InputNumber,
    Radio,
    RadioGroup,
    RadioButton,
    Checkbox,
    CheckboxButton,
    CheckboxGroup,
    Switch,
    Select,
    Option,
    // OptionGroup,
    Button,
    ButtonGroup,
    Table,
    TableColumn,
    DatePicker,
    TimeSelect,
    TimePicker,
    Popover,
    Tooltip,
    Breadcrumb,
    BreadcrumbItem,
    Form,
    FormItem,
    Tabs,
    TabPane,
    Tag,
    Tree,
    // Alert,
    // Slider,
    Icon,
    Row,
    Col,
    Upload,
    Progress,
    Spinner,
    // Badge,
    Card,
    // Rate,
    Steps,
    Step,
     Carousel,
    Scrollbar,
  Message,
    CarouselItem,
    Collapse,
    CollapseItem,
    Cascader,
    // ColorPicker,
    Transfer
]
import enLocale from 'element-ui/lib/locale/lang/en'

import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
locale.use(lang)

const install = function (Vue, opts = {}) {
    components.map(component => {
        Vue.component(component.name, component)
    })
    // Vue.use()
    Vue.use(Loading.directive)
    Vue.prototype.$loading = Loading.service
    Vue.prototype.$msgbox = MessageBox
    Vue.prototype.$alertEl = MessageBox.alert
    Vue.prototype.$confirm = MessageBox.confirm
    Vue.prototype.$prompt = MessageBox.prompt
    Vue.prototype.$notify = Notification
    Vue.prototype.$message = Message
}

export default {
    version: '2.0.11',
    install
}



// WEBPACK FOOTER //
// ./src/common/element-index.js